// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAYOUT */

.page{
    position:relative;
    display:flex;
    gap:30px;
    padding:40px 7%;
}

.filter-btn{
    position:absolute;
    display:block;
    text-align:center;
    text-decoration:none;
    background:#0f172a;
    color:white;
    padding:14px;
    border-radius:50%;
    font-weight:600;
    transition:.3s;
    top: 32px;
    right: 16px;
    z-index: 9;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 16px -6px rgba(0, 0, 0, 0.3);
}

@media(max-width:900px){
  .page{
    flex-direction:column;
    padding: 20px 10px;
  }
  .sidebar{
    width:100%;
  }
  .topbar{
    flex-direction:column;
    align-items:flex-start;
    gap:15px;
  }
  .search{
    width:100%;
  }
}

@media(min-width:768px){
  .filter-btn{
    display:none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Listing/css/Listing.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;IACI,iBAAiB;IACjB,YAAY;IACZ,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,SAAS;IACT,WAAW;IACX,UAAU;IACV,mFAAmF;AACvF;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* LAYOUT */\r\n\r\n.page{\r\n    position:relative;\r\n    display:flex;\r\n    gap:30px;\r\n    padding:40px 7%;\r\n}\r\n\r\n.filter-btn{\r\n    position:absolute;\r\n    display:block;\r\n    text-align:center;\r\n    text-decoration:none;\r\n    background:#0f172a;\r\n    color:white;\r\n    padding:14px;\r\n    border-radius:50%;\r\n    font-weight:600;\r\n    transition:.3s;\r\n    top: 32px;\r\n    right: 16px;\r\n    z-index: 9;\r\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 16px -6px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n@media(max-width:900px){\r\n  .page{\r\n    flex-direction:column;\r\n    padding: 20px 10px;\r\n  }\r\n  .sidebar{\r\n    width:100%;\r\n  }\r\n  .topbar{\r\n    flex-direction:column;\r\n    align-items:flex-start;\r\n    gap:15px;\r\n  }\r\n  .search{\r\n    width:100%;\r\n  }\r\n}\r\n\r\n@media(min-width:768px){\r\n  .filter-btn{\r\n    display:none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
